import React from 'react';
import { CommentCard } from '../../molecules/CommentCard';
import { type Comment } from '../../../services/commentsService';

export interface CommentsListProps {
  comments: Comment[];
  deletingId: number | null;
  onDeleteClick: (comment: Comment) => void;
}

export const CommentsList = ({ comments, deletingId, onDeleteClick }: CommentsListProps) => {
  console.log(comments);
  return (
    <div className="space-y-4 mb-6">
      {comments.map((comment) => (
        <CommentCard
          key={comment.id}
          comment={comment}
          deletingId={deletingId}
          onDeleteClick={onDeleteClick}
        />
      ))}
    </div>
  );
};
